module.exports = __webpack_public_path__ + "static/media/icon-org-page-organisation.b8451e47.svg";